export default __webpack_public_path__ + "static/media/privacy.544278f4.svg";